"use client";

import { FC } from "react";
import dynamic from "next/dynamic";
import { BuilderContextInterface } from "@builder.io/sdk-react";

const ItsmPdfButtons = dynamic(
  () => import("@/components/ITSMMaturityModel/ItsmPdf/ItsmPdfButtons"),
);

type ItsmPdfButtonsBlockProps = {
  downloadButtonText: string;
  downloadButtonDld?: string;
  downloadButtonDlt?: string;
  printButtonText: string;
  printButtonDld?: string;
  printButtonDlt?: string;
  startNewModelButtonText: string;
  startNewModelButtonDld?: string;
  startNewModelButtonDlt?: string;
  modalHeadline: string;
  modalDescription: string;
  modalBackButtonText: string;
  modalStartNewButtonText: string;
  pdfTitle: string;
  builderContext: BuilderContextInterface;
};

export const ItsmPdfButtonsBlock: FC<ItsmPdfButtonsBlockProps> = ({
  downloadButtonText,
  downloadButtonDld,
  downloadButtonDlt,
  printButtonText,
  printButtonDld,
  printButtonDlt,
  startNewModelButtonText,
  startNewModelButtonDld,
  startNewModelButtonDlt,
  modalHeadline,
  modalDescription,
  modalBackButtonText,
  modalStartNewButtonText,
  pdfTitle,
  builderContext,
}) => {
  const image = builderContext.rootState?.itsmImage as string | undefined;
  const formData = builderContext.rootState?.itsmFormData as
    | {
        name?: string;
        company?: string;
        challenge?: string;
      }
    | undefined;

  const handleClearModel = () => {
    if (builderContext?.rootSetState) {
      builderContext.rootSetState({
        ...builderContext.rootState,
        itsmImage: undefined,
        itsmFormData: undefined,
        itsmView: "table",
        selectedChallenge: null,
      });
    }
  };

  return (
    <>
      <ItsmPdfButtons
        pdfButtons={{
          downloadButton: {
            buttonText: downloadButtonText,
            dld: downloadButtonDld,
            dlt: downloadButtonDlt,
          },
          printButton: {
            buttonText: printButtonText,
            dld: printButtonDld,
            dlt: printButtonDlt,
          },
          startNewModelButton: {
            buttonText: startNewModelButtonText,
            dld: startNewModelButtonDld,
            dlt: startNewModelButtonDlt,
          },
        }}
        clearModal={{
          headline: modalHeadline,
          description: modalDescription,
          backButtonText: modalBackButtonText,
          startNewButtonText: modalStartNewButtonText,
        }}
        clearModel={handleClearModel}
        pdf={{
          image: image ?? "",
          title: pdfTitle,
          name: formData?.name ?? "",
          company: formData?.company ?? "",
          challenge: formData?.challenge,
        }}
      />
      {!image ? (
        <div className="py-8 text-center text-gray-500">
          No image available.
        </div>
      ) : (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={image}
          alt="ITSM Maturity Model"
          className="mx-auto max-w-323"
        />
      )}
    </>
  );
};
